import { ApplicationConfig } from "@angular/core";
import { provideRouter, withEnabledBlockingInitialNavigation } from "@angular/router";
import { provideHttpClient, withFetch, withInterceptors } from "@angular/common/http";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { routes } from "./app.routes";
import { UserStore } from "./store/user.store";
import { environment } from "../environments/environment";
import { BASE_PATH } from "./services/api";
import { authInterceptor } from "./interceptor/auth.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withEnabledBlockingInitialNavigation()),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    UserStore,
    { provide: BASE_PATH, useValue: environment.baseUrl },
  ],
};
